<template>
    <div class="home">
        <div class="takeda-logo">
            <svg viewBox="0 0 158 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                <path d="M78.1001 0C27.5001 0 0.600098 35.9 0.600098 35.9L11.6001 43.3C11.6001 43.3 12.9001 40 16.0001 35.2C16.0001 36.4 16.2001 37.2 16.2001 37.2C18.1001 52.4 32.8001 52 32.8001 52H123.7C123.7 52 138.6 52.4 140.5 37.3C140.5 37.3 140.6 36.5 140.7 35.3C143.7 40 145 43.2 145 43.2L156 35.8C156 35.9 128.7 0 78.1001 0Z" fill="#E30613"/>
                <path d="M138.3 37.1C138.3 37.1 136.3 48.6 123.6 48.6H32.7C20 48.7 18.2 37 18.2 37C17.7 33.9 18.3 31.8 19.3 30.3C28.4 18.2 46.6 2 78.1 2C109.8 2 128.1 18.5 137.3 30.6C138.3 31.9 138.7 34.1 138.3 37.1Z" fill="white"/>
                <path d="M126.5 37.5C126.5 37.5 125.5 37.9 125.1 37.5C124.7 37.1 125 36.3 125 36.3L129.1 27.7H125L124.4 28.8C122 26.7 117.4 27.8 114.5 30.7C112.9 32.4 111.9 34.4 111.8 36.2C111.3 36.5 110.6 37 109.6 37.4C109.6 37.4 108.6 37.9 108.2 37.4C107.8 37 108.1 36.2 108.1 36.2L115.4 21.2H111.2L107.4 28.7C105 26.6 100.4 27.7 97.5001 30.6C96.9001 31.2 96.4001 31.8 96.0001 32.5C96.0001 32.6 95.9001 32.6 95.9001 32.7C95.8001 32.9 95.7001 33 95.6001 33.2C93.3001 37.1 90.5001 37.8 90.5001 37.8C84.5001 39.6 83.8001 36.7 83.8001 36.7C90.5001 34.2 93.0001 31.3 92.8001 29C92.6001 26.8 89.5001 26.6 89.5001 26.6C84.4001 26.3 80.1001 29.8 79.0001 33.3C78.7001 34.4 78.6001 35.4 78.8001 36.4C76.8001 37.5 75.6001 37.6 75.6001 37.6C73.9001 38.1 73.7001 37.3 73.5001 36.8C73.3001 36.3 72.6001 32 72.6001 32L79.7001 27.4H75.4001L70.1001 30.7C68.9001 31.2 69.4001 29.9 69.4001 29.9L73.8001 21.1H69.6001L62.5001 35.4C61.7001 35.9 60.0001 36.8 58.9001 37.3C58.9001 37.3 57.9001 37.8 57.5001 37.3C57.1001 36.9 57.4001 36.1 57.4001 36.1L61.5001 27.5H57.3001L56.7001 28.7C54.3001 26.6 49.7001 27.7 46.8001 30.6C44.0001 33.6 43.2001 37.5 45.2001 39.4C46.8001 40.9 49.6001 40.6 52.1001 38.9C52.1001 38.9 52.7001 38.4 53.1001 39C53.5001 39.7 54.9001 41.2 58.2001 39.9C59.3001 39.5 60.2001 39 61.0001 38.5L60.0001 40.3H64.2001L66.3001 36.1L68.1001 34.9C68.1001 34.9 68.6001 34.5 68.9001 35.4C68.9001 35.4 69.8001 39 70.2001 39.4C70.5001 39.9 71.2001 40.9 74.2001 40.1C76.4001 39.5 78.6001 38.7 79.7001 38.2C80.7001 39.6 82.6001 40.5 85.7001 40.5C90.3001 40.5 93.5001 38.3 94.9001 37.2C95.0001 38.1 95.4001 38.9 96.0001 39.5C97.6001 41 100.4 40.7 102.9 39C102.9 39 103.5 38.5 103.9 39.1C104.3 39.8 105.7 41.3 109 40C110.5 39.4 111.5 38.8 112.2 38.4C112.4 38.9 112.6 39.3 113 39.6C114.6 41.1 117.4 40.8 119.9 39.1C119.9 39.1 120.5 38.6 120.9 39.2C121.3 39.9 122.7 41.4 126 40.1C129.3 38.8 130.3 37.6 130.3 37.6L129.5 36.1C129.2 36.1 128.1 36.9 126.5 37.5ZM53.9001 35C52.5001 37 50.4001 38.1 49.3001 37.3C48.2001 36.5 48.5001 34.3 50.0001 32.2C51.4001 30.2 53.5001 29.1 54.6001 29.9C55.7001 30.7 55.4001 33 53.9001 35ZM83.6001 33.6C83.6001 33.6 84.5001 30.4 87.6001 29.2C87.6001 29.2 88.5001 28.9 88.9001 29.3C88.9001 29.3 89.6001 29.9 88.8001 31.1C88.1001 32.1 86.5001 34 84.6001 34.6C84.6001 34.5 83.0001 35.3 83.6001 33.6ZM104.7 35C103.3 37 101.2 38.1 100.1 37.3C99.0001 36.5 99.3001 34.3 100.8 32.2C102.2 30.2 104.3 29.1 105.4 29.9C106.4 30.7 106.2 33 104.7 35ZM121.7 35.1C120.3 37.1 118.2 38.2 117.1 37.4C116 36.6 116.3 34.4 117.8 32.3C119.2 30.3 121.3 29.2 122.4 30C123.5 30.8 123.2 33.1 121.7 35.1Z" fill="#E30613"/>
                <path d="M51.5999 24.5L53.0999 21.3H33.6999L32.1999 24.5H39.6999L31.8999 40.4H36.8999L44.6999 24.5H51.5999Z" fill="#E30613"/>
                <path d="M11.2 71.9C11.2 70 10.8 68.6 10 67.6C9.2 66.6 8.1 66.1 6.6 66.1C5.9 66.1 5.3 66.2 4.7 66.5C4.1 66.8 3.7 67.1 3.3 67.6C2.9 68.1 2.6 68.7 2.4 69.4C2.2 70.1 2.1 70.9 2.1 71.9C2.1 72.8 2.2 73.6 2.4 74.3C2.6 75 2.9 75.6 3.3 76.1C3.7 76.6 4.1 77 4.7 77.3C5.3 77.6 5.9 77.7 6.7 77.7C7.4 77.7 8.1 77.6 8.6 77.3C9.2 77 9.6 76.6 10 76.1C10.4 75.6 10.7 75 10.9 74.3C11.1 73.6 11.2 72.8 11.2 71.9ZM13.4 71.9C13.4 73 13.3 73.9 13 74.8C12.7 75.7 12.3 76.5 11.8 77.1C11.2 77.7 10.5 78.3 9.7 78.6C8.9 79 7.9 79.2 6.7 79.2C5.6 79.2 4.6 79 3.8 78.7C3 78.4 2.3 77.9 1.7 77.2C1.1 76.6 0.7 75.8 0.4 74.9C0.1 74 0 73 0 71.9C0 70.8 0.1 69.9 0.4 69C0.7 68.1 1.1 67.3 1.6 66.7C2.1 66.1 2.8 65.5 3.7 65.2C4.5 64.8 5.5 64.6 6.7 64.6C7.8 64.6 8.8 64.8 9.6 65.1C10.4 65.4 11.1 65.9 11.7 66.6C12.3 67.2 12.7 68 13 68.9C13.3 69.8 13.4 70.8 13.4 71.9Z" fill="white"/>
                <path d="M34.4 78.6C34.4 78.9 34.3 79 34 79H32.7C32.6 79 32.5 79 32.4 79C32.3 79 32.3 78.9 32.2 78.9C32.1 78.8 32 78.7 32 78.6C31.9 78.5 31.8 78.3 31.7 78.1L25.4 67.6C25.3 67.5 25.3 67.4 25.2 67.4C25.1 67.4 25.1 67.5 25.1 67.6V78.7C25.1 79 25 79.1 24.8 79.1H23.8C23.6 79.1 23.5 79 23.5 78.7V65.2C23.5 64.9 23.6 64.8 23.9 64.8H25.7C25.8 64.8 25.9 64.8 26 64.9C26.1 64.9 26.2 65 26.2 65.2L32.5 75.7C32.6 75.8 32.6 75.9 32.7 75.9C32.8 75.9 32.8 75.8 32.8 75.7V65.2C32.8 64.9 32.9 64.8 33.1 64.8H34.1C34.2 64.8 34.3 64.8 34.3 64.9C34.4 65 34.4 65.1 34.4 65.2V78.6Z" fill="white"/>
                <path d="M55.7001 77.9C55.7001 78.1 55.6001 78.3 55.4001 78.4C55.0001 78.6 54.4 78.8 53.8 79C53.2 79.1 52.5 79.2 51.6 79.2C50.5 79.2 49.5 79.1 48.6 78.8C47.7 78.5 46.9 78.1 46.3 77.5C45.7 76.9 45.2 76.2 44.8 75.3C44.4 74.4 44.3 73.4 44.3 72.2C44.3 71 44.5 70 44.8 69C45.1 68.1 45.6 67.3 46.3 66.6C46.9 65.9 47.7 65.4 48.6 65.1C49.5 64.8 50.5001 64.6 51.7001 64.6C52.5001 64.6 53.2 64.7 53.8 64.8C54.4 64.9 54.9 65.1 55.3 65.4C55.5 65.5 55.6 65.7 55.6 65.9V66.8C55.6 67 55.5 67.1 55.3 67.1C55.2 67.1 55.1001 67.1 54.9001 67C54.7001 66.9 54.5001 66.8 54.2001 66.7C53.9001 66.6 53.6 66.5 53.2001 66.4C52.8001 66.3 52.4001 66.3 51.9001 66.3C50.0001 66.3 48.7001 66.8 47.7001 67.9C46.8001 69 46.3 70.5 46.3 72.3C46.3 74.1 46.7 75.4 47.6 76.3C48.5 77.2 49.8 77.7 51.5 77.7C52.1 77.7 52.7 77.7 53.1 77.6C53.5 77.5 53.9 77.4 54.1 77.3C54.4 77.2 54.6 77.1 54.7001 77C54.9001 76.9 55 76.9 55.1 76.9C55.3 76.9 55.5 77 55.5 77.2V77.9H55.7001Z" fill="white"/>
                <path d="M75.6 71.9C75.6 70 75.2 68.6 74.4 67.6C73.6 66.6 72.5 66.1 71 66.1C70.3 66.1 69.7 66.2 69.1 66.5C68.5 66.8 68.1 67.1 67.7 67.6C67.3 68.1 67 68.7 66.8 69.4C66.6 70.1 66.5 70.9 66.5 71.9C66.5 72.8 66.6 73.6 66.8 74.3C67 75 67.3 75.6 67.7 76.1C68.1 76.6 68.5 77 69.1 77.3C69.7 77.6 70.3 77.7 71.1 77.7C71.8 77.7 72.5 77.6 73 77.3C73.6 77 74 76.6 74.4 76.1C74.8 75.6 75.1 75 75.3 74.3C75.5 73.6 75.6 72.8 75.6 71.9ZM77.7 71.9C77.7 73 77.6 73.9 77.3 74.8C77 75.7 76.6 76.5 76.1 77.1C75.5 77.7 74.8 78.3 74 78.6C73.2 79 72.2 79.2 71 79.2C69.9 79.2 68.9 79 68.1 78.7C67.3 78.4 66.6 77.9 66 77.2C65.4 76.6 65 75.8 64.7 74.9C64.4 74 64.3 73 64.3 71.9C64.3 70.8 64.4 69.9 64.7 69C65 68.1 65.4 67.3 65.9 66.7C66.4 66.1 67.1 65.5 68 65.2C68.8 64.8 69.8 64.6 71 64.6C72.1 64.6 73.1 64.8 73.9 65.1C74.7 65.4 75.4 65.9 76 66.6C76.6 67.2 77 68 77.3 68.9C77.6 69.8 77.7 70.8 77.7 71.9Z" fill="white"/>
                <path d="M95.1001 78.6C95.1001 78.9 95.0001 79 94.7001 79H88.0001C87.8001 79 87.6001 78.9 87.6001 78.6V65.2C87.6001 64.9 87.7001 64.8 88.0001 64.8H89.3001C89.6001 64.8 89.7001 64.9 89.7001 65.2V77.2C89.7001 77.4 89.8001 77.5 90.0001 77.5H94.7001C95.0001 77.5 95.1001 77.6 95.1001 77.9V78.6Z" fill="white"/>
                <path d="M114.3 71.9C114.3 70 113.9 68.6 113.1 67.6C112.3 66.6 111.2 66.1 109.7 66.1C109 66.1 108.4 66.2 107.8 66.5C107.2 66.8 106.8 67.1 106.4 67.6C106 68.1 105.7 68.7 105.5 69.4C105.3 70.1 105.2 70.9 105.2 71.9C105.2 72.8 105.3 73.6 105.5 74.3C105.7 75 106 75.6 106.4 76.1C106.8 76.6 107.2 77 107.8 77.3C108.4 77.6 109 77.7 109.8 77.7C110.5 77.7 111.2 77.6 111.7 77.3C112.3 77 112.7 76.6 113.1 76.1C113.5 75.6 113.8 75 114 74.3C114.2 73.6 114.3 72.8 114.3 71.9ZM116.5 71.9C116.5 73 116.4 73.9 116.1 74.8C115.8 75.7 115.4 76.5 114.9 77.1C114.3 77.7 113.6 78.3 112.8 78.6C112 79 111 79.2 109.8 79.2C108.7 79.2 107.7 79 106.9 78.7C106.1 78.4 105.4 77.9 104.8 77.2C104.2 76.6 103.8 75.8 103.5 74.9C103.2 74 103.1 73 103.1 71.9C103.1 70.8 103.2 69.9 103.5 69C103.8 68.1 104.2 67.3 104.7 66.7C105.3 66.1 105.9 65.5 106.8 65.2C107.6 64.8 108.6 64.6 109.8 64.6C110.9 64.6 111.9 64.8 112.7 65.1C113.5 65.4 114.2 65.9 114.8 66.6C115.4 67.2 115.8 68 116.1 68.9C116.3 69.8 116.5 70.8 116.5 71.9Z" fill="white"/>
                <path d="M137.3 77.9C137.3 78.1 137.3 78.2 137.2 78.3C137.1 78.4 137 78.5 136.7 78.6C136.3 78.8 135.8 78.9 135.2 79C134.6 79.1 133.8 79.2 133.1 79.2C132 79.2 131 79.1 130.1 78.8C129.2 78.5 128.4 78.1 127.8 77.5C127.2 76.9 126.7 76.2 126.3 75.3C125.9 74.4 125.8 73.4 125.8 72.2C125.8 71 126 70 126.3 69C126.6 68.1 127.1 67.3 127.8 66.6C128.4 65.9 129.2 65.4 130.1 65.1C131 64.8 132 64.6 133.2 64.6C134 64.6 134.7 64.7 135.2 64.8C135.8 64.9 136.3 65.1 136.7 65.2C137 65.3 137.2 65.4 137.3 65.5C137.4 65.6 137.4 65.7 137.4 65.9V66.8C137.4 67 137.3 67.1 137.1 67.1C137 67.1 136.9 67.1 136.7 67C136.5 66.9 136.3 66.8 136 66.7C135.7 66.6 135.4 66.5 135 66.4C134.6 66.3 134.2 66.3 133.7 66.3C131.8 66.3 130.4 66.8 129.5 67.9C128.6 69 128.1 70.4 128.1 72.3C128.1 74.1 128.5 75.4 129.4 76.4C130.3 77.3 131.6 77.8 133.3 77.8C134.1 77.8 134.7 77.7 135 77.6C135.3 77.5 135.5 77.3 135.5 77.2V73.2C135.5 72.9 135.6 72.8 135.9 72.8H137.2C137.5 72.8 137.6 72.9 137.6 73.2V77.9H137.3Z" fill="white"/>
                <path d="M157.5 65C157.5 65.1 157.5 65.3 157.4 65.4L153.3 72.6C153.2 72.8 153.1 72.9 153.1 73C153.1 73.1 153.1 73.3 153.1 73.6V78.6C153.1 78.9 153 79 152.7 79H151.3C151.1 79 151 78.9 151 78.6V73.9C151 73.6 151 73.4 150.9 73.3C150.9 73.2 150.8 73 150.7 72.8L146.5 65.5C146.4 65.4 146.4 65.3 146.4 65.2C146.4 65.1 146.4 65.1 146.4 65C146.4 64.9 146.4 64.9 146.5 64.8C146.6 64.8 146.6 64.7 146.7 64.7H148.2C148.3 64.7 148.4 64.7 148.5 64.8C148.6 64.8 148.6 64.9 148.7 65L152 71C152.1 71.1 152.2 71.2 152.3 71.2C152.4 71.2 152.4 71.1 152.5 71L155.8 65C155.9 64.9 155.9 64.8 156 64.7C156.1 64.7 156.2 64.6 156.3 64.6H157.3C157.4 64.8 157.5 64.9 157.5 65Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0">
                <rect width="157.5" height="79.2" fill="white"/>
                </clipPath>
                </defs>
            </svg>
        </div>

        <div class="hello-block">
            <!-- <div class="logo">
                <img src="../assets/images/moderator/adcetris-logo.png" alt="">
            </div> -->

            <div class="hello-title">Вітаємо!</div>

            <div class="hello-under">
                Складіть портрет пацієнта з CD30+ ЛХ ІVстадії та нодулярним склерозом, для якого, на Вашу думку, терапія за схемою BV+AVD буде максимально ефективною
            </div>

            <div class="next-button">
                <button type="button" @click="checkEvents()">
                    Далі
                    <div class="arrow">
                        <svg width="14" height="14" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.25282 12C1.14825 12 0.252818 12.8954 0.252818 14C0.252818 15.1046 1.14825 16 2.25282 16L2.25282 12ZM24.0945 14L25.4806 15.4417C25.8728 15.0646 26.0945 14.5441 26.0945 14C26.0945 13.4559 25.8728 12.9354 25.4806 12.5583L24.0945 14ZM10.2274 24.5583C9.43113 25.3238 9.40626 26.5899 10.1718 27.3862C10.9374 28.1824 12.2035 28.2073 12.9997 27.4417L10.2274 24.5583ZM12.9997 0.55828C12.2035 -0.207276 10.9374 -0.182403 10.1718 0.613837C9.40626 1.41007 9.43113 2.67616 10.2274 3.44172L12.9997 0.55828ZM2.25282 16L24.0945 16L24.0945 12L2.25282 12L2.25282 16ZM22.7083 12.5583L10.2274 24.5583L12.9997 27.4417L25.4806 15.4417L22.7083 12.5583ZM25.4806 12.5583L12.9997 0.55828L10.2274 3.44172L22.7083 15.4417L25.4806 12.5583Z" fill="white"/>
                        </svg>
                    </div>
                </button>
            </div>
        </div>

        <home-footer />
    </div>
</template>

<script>
import axios from 'axios';
import HomeFooter from '../components/Doctor/HomeFooter';
import { mapGetters, mapMutations } from 'vuex';

export default {
    components : {
        'home-footer' : HomeFooter
    },
    data : () => ({
        activeEvents : []
    }),
    computed : {
        ...mapGetters([
            'getEventId',
            'getCurrentRoute'
        ])
    },
    created(){
        this.fullRresetPatient();
    },
    methods : {
        ...mapMutations([
            'setEventId',
            'fullRresetPatient'
        ]),
        checkEvents(){
            if(this.$route.params.hasOwnProperty('id')){
                
                axios.get('/api/Doctor/CheckEventIsExist/' + this.$route.params.id)
                .then(() => {
                    this.setEventId(this.$route.params.id);

                    if(this.getCurrentRoute === '')
                        this.$router.push('/create-patient/stage/1');
                    else
                        this.$router.push(this.getCurrentRoute);  
                })
                .catch(() => {
                    this.$router.push('/room-not-exist');
                })                 
            }
            else{
                if(this.getEventId){
                    if(this.getCurrentRoute === '')
                        this.$router.push('/create-patient');
                    else
                        this.$router.push(this.getCurrentRoute);   
                }
                else{
                    axios.get('/api/Doctor/GetActiveEvents')
                    .then(response => {
                        if(response.data.length === 0){
                            this.$router.push('/no-events');
                        }
                        else if(response.data.length === 1){
                            this.$store.commit('setEventId', response.data[0].id);
                            this.$router.push('/create-patient');
                        }
                        else{
                            this.$router.push({ name: 'select-conference', params: { events: response.data } })
                        }
                    })
                }
            }            
        }
    }
}
</script>

<style lang="scss">
*, body {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-focus-ring-color: rgba(0,0,0,0);
    outline: none;
}

.home{
    width: 100%;
    height: 100%;
    background: url("../assets/images/doctor/bg-doctor.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% auto;

    display: flex;
    align-items: center;
    justify-content: center;

    .takeda-logo{
        position: fixed;
        top: 46px;
        right: 33px;

        svg{
            width: 79px;
            height: auto;
        }
    }

    .hello-block{
        padding: 0 21% 10%;
    }

    .logo{
        img{
            width: 268px;
            height: auto;
        }

        padding-bottom: 18px;
    }

    .hello-title{
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
        line-height: 60px;

        text-align: center;

        color: #FFFFFF;

        padding-bottom: 18px;
    }

    .hello-under{
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 26px;

        text-align: center;

        color: #FFFFFF;

        padding-bottom: 40px;
    }

    .next-button{

        button{
            position: relative;

            border: none;
            outline: none;

            background: linear-gradient(270.22deg, #F9A900 10.58%, #FF7DA5 140.06%);
            border-radius: 100px;

            padding: 13px 57px;

            font-style: normal;
            font-weight: 750;
            font-size: 16px;
            line-height: 24px;

            color: #FFFFFF;

            .arrow{
                position: absolute;
                top: 14px;
                right: 14px;
            }
        }
    }
}

.webp{
    .home{
        background: url("../assets/images/doctor/bg-doctor.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
}


@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .home{
        background-size: cover;

        .takeda-logo{
            top: 4.199vw;
            right: 3.223vw;

            svg{
                width: 7.715vw;
            }
        }

        .hello-block{
            padding-bottom: 0;
        }

        .logo{
            img{
                width: 26.172vw;
            }

            padding-bottom: 1.758vw;
        }

        .hello-title{
            font-size: 3.516vw;
            line-height: 5.859vw;

            padding-bottom: 1.758vw;
        }

        .hello-under{
            font-size: 1.953vw;
            line-height: 2.539vw;

            padding: 0 7vw;
            padding-bottom: 3.906vw;
        }

        .next-button{

            button{
                padding: 1.270vw 5.566vw;

                font-size: 1.563vw;
                line-height: 2.344vw;


                .arrow{
                    top: 1.367vw;
                    right: 1.367vw;
                }
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 21/9) {
    .home{
        .takeda-logo{
            top: 2vw;

            svg{
                width: 5vw;
            }
        }

        .logo{
            img{
                width: 20vw;
            }

            padding-bottom: 1.5vw;
        }

        .hello-title{
            font-size: 2.5vw;
            line-height: 3vw;

            padding-bottom: 1.5vw;
        }

        .hello-under{
            font-size: 1.5vw;
            line-height: 2vw;

            padding-bottom: 2.5vw;
        }

        .next-button{

            button{
                padding: 0.8vw 5vw;

                font-size: 1.2vw;
                line-height: 2vw;


                .arrow{
                    top: 0.9vw;

                    svg{
                        width: 1vw;
                        height: auto;
                    }
                }
            }
        }
    }
}

@media (max-width: 599px){
    .webp{
        .home{
            background: url("../assets/images/doctor/bg-doctor-mobile.webp");
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
    }

    .home{
        background: url("../assets/images/doctor/bg-doctor-mobile.png");
        background-size: cover;
        
        flex-direction: column;
        align-items: flex-start;

        .takeda-logo{
            top: 2.778vw;
            right: 2.778vw;

            svg{
                width: 18.889vw;
            }
        }

        .hello-block{
            padding: 0;
            padding-top: 13.333vw;
        }

        .logo{
            img{
                width: 71.111vw;
            }

            padding-bottom: 0;
        }

        .hello-title{
            font-size: 7.778vw;
            line-height: 15.556vw;

            padding-bottom: 0;
        }

        .hello-under{
            font-size: 5vw;
            line-height: 7.222vw;

            padding: 0 4.444vw;
            padding-bottom: 6.667vw;
        }

        .next-button{

            button{
                padding: 4.167vw 20.833vw;

                font-size: 5vw;
                line-height: 24px;

                .arrow{
                    top: 4.444vw;
                    right: 4.444vw;
                }
            }
        }
    }
}
</style>